import CountUp from 'react-countup'
import {BaseProps} from "../types";

type AnimationNumberProps = {
  value: string
}

export default function AnimationNumber(props: BaseProps<AnimationNumberProps>) {
  const number = Number(props.data?.value) || 0
  return (
    <CountUp end={number} duration={5} decimal={','} />
  )
}